import { render, staticRenderFns } from "./DDHeader.vue?vue&type=template&id=3bc84469&scoped=true"
import script from "./DDHeader.vue?vue&type=script&lang=js"
export * from "./DDHeader.vue?vue&type=script&lang=js"
import style0 from "./DDHeader.vue?vue&type=style&index=0&id=3bc84469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc84469",
  null
  
)

export default component.exports